import "../Enroll/HeaderHero.scss";
import "./HeavyUpFormHeader.scss";
import { Link } from "react-router-dom";

function HeavyUpFormHeader() {
	return (
		<div className="form-hero-container hu-form-header">
			<div className="logo-container-wrapper">
				<div className="logo-container">
					<div className="header-hero-bar-left">
						<Link to="/heavy-up-enrollment" className="header-hero-back">
							← BACK
						</Link>
					</div>
					<div className="header-hero-bar-center">
						<div className="logo-text">
							<p>JLR</p>
							<p>RETAILER DIGITAL PROGRAM</p>
						</div>
					</div>
					<div className="header-hero-bar-right">
						<p className="header-hero-trailing">
							POWERED BY CONSTELLATION
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default HeavyUpFormHeader;
